export class UseCaseGetDailyValue {
    handle(price, totalDays) {
        let firstValue = parseInt(price, 10);
        // divide an remove the decimals
        let floatPrice = Math.floor(firstValue / totalDays);
        // return the value with the format
        return floatPrice.toLocaleString("en-US");
    }
}
